import * as React from 'react'
import logo from '../static/images/New_logo.jpg'
import {MenuUnfoldOutlined, UserOutlined} from '@ant-design/icons'
import {Route, Link, BrowserRouter as Router} from 'react-router-dom'
import {Menu, Input, Avatar, Icon, Select} from 'antd'
import Notifications from '../components/notification'
const SubMenu = Menu.SubMenu

const Search = Input.Search

const trgLogout = () => {
  localStorage.clear()
  window.location.href = '/'
}

class HeaderDiv extends React.Component {
  constructor() {
    super()
    this.state = {
      current: 'search',
      rtl: true,
      user: localStorage.getItem('username'),
      productName: localStorage.getItem('productName'),
    }
    this.sidebarToggle = this.sidebarToggle.bind(this)
  }

  sidebarToggle() {
    this.setState({
      rtl: !this.state.rtl,
    })
    var body = document.body
    body.classList.toggle('rtl')
  }

  handleClick = e => {
    console.log('click ', e)
    this.setState({
      current: e.key,
    })
  }

  render() {
    const classBox = `primaryBg box`

    return (
      <Menu
        key="header"
        mode="horizontal"
        theme="dark"
        className="d-flex align-items-center custom-navigation">
        <Menu.Item key="brand-logo" className="brand-logo">
          <Link to="/claims">
            <img src={logo} className="logo-img" />
          </Link>
        </Menu.Item>
        <Menu.Item key="brand-logo" className="brand-logo">
          {window.innerWidth > 800 && (
            <div onClick={this.props.toggleSidebar} className="sidebar-toggle">
              <MenuUnfoldOutlined />
            </div>
          )}
        </Menu.Item>
        {/* <div
          style={{
            marginLeft: 'auto',
            paddingRight: '1rem',
            display: 'flex',
            alignItems: 'center',
          }}>
          <Menu.Item key="brand-logo" className="brand-logo">
            <label style={{fontWeight: 500, marginBottom: 5, marginRight: 5}}>
              Select Product :
            </label>
            <Select
              placeholder="Select Product"
              style={{width: 200}}
              optionFilterProp="children"></Select>
          </Menu.Item>
        </div> */}
        <div
          style={{
            marginLeft: 'auto',
            paddingRight: '1rem',
            display: 'flex',
            alignItems: 'center',
          }}>
          <Menu.Item key="brand-logo" className="brand-logo">
            <Notifications />
          </Menu.Item>
        </div>
        <SubMenu
          key="profile"
          title={
            <span>
              <div className=" avatar-profile">
                <Avatar size={32} icon={<UserOutlined />} />
                <span
                  style={{fontSize: '12px', fontWeight: '500', height: '28px'}}>
                  {' '}
                  {this.state.user}
                </span>
              </div>
            </span>
          }
          className="avatar-round">
          <Menu.Item key="logout">
            <div
              onClick={() => {
                trgLogout()
              }}>
              Logout
            </div>
          </Menu.Item>
        </SubMenu>
      </Menu>
    )
  }
}
export default HeaderDiv
